<template>
    <div class="timeline-card__reply">
        <span class="d-block"> {{ formattedDate }} - {{ formattedTime }}</span>
        <div class="text-black" v-html="repliesTo.message"></div>
    </div>
</template>

<script lang="ts" src="./TimelineCardRepliesTo.ts"></script>
